const selectionButtonStyles = theme => ({
  '.selection-button-wrapper': {
    display: 'inline-block',
    cursor: 'pointer',

    // Force override of styles from AntD
    "form & input[type='radio']": {
      width: '100%',
      height: '100%',
    },
  },

  '.selection-button': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,
    borderRadius: '6px',
    padding: '10px 15px',
    backgroundColor: theme('colors.white'),
    color: theme('colors.green1.55'),

    '.selection-button-peer:hover ~ &, .selection-button-peer:active ~ &, .selection-button-peer:focus ~ &':
      {
        boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.55')}`,
        boxSizing: 'border-box',
      },

    '.selection-button-peer:disabled ~ &': {
      color: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.30')}`,
    },

    '.selection-button-peer:checked ~ &': {
      color: theme('colors.white'),
      backgroundColor: theme('colors.green1.60'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.60')}`,
    },

    '.selection-button-peer:checked:hover ~ &, .selection-button-peer:checked:focus ~ &': {
      backgroundColor: theme('colors.green1.55'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,
    },

    '.selection-button-peer:checked:active ~ &': {
      backgroundColor: theme('colors.green1.50'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.50')}`,
    },

    '.selection-button-peer:checked.disabled ~ &': {
      backgroundColor: theme('colors.green1.30'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.30')}`,
    },
  },
});

module.exports = { selectionButtonStyles };
